import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';
const latitude = localStorage.getItem('latitude');
const longitude = localStorage.getItem('longitude');

const handleApiRequest = async (method, endpoint, payload = null) => {
    try {
        const response =
            method === 'GET'
                ? await merchantCommonGetRequest(endpoint, payload) // Pass params for GET
                : await merchantCommonPost(endpoint, payload); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};
const merchantCommonPost = async (apiEndPoint, payload) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    let merchantEmpID;
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
const merchantCommonGetRequest = async (apiEndPoint, params) => {
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    let merchantEmpID;
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.get(
            endPoint,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};

export const GET_API_ENDPOINTS = {
    getMasterAccountRoles: 'accounts/getMasterAccountRoles'
};
export const POST_API_ENDPOINTS = {
    addEmployeePortalStatus: 'accounts/getMasterAccountRoles',
    getMasterAccounts: 'accounts/getMasterAccounts',
    addDoubleEntry: 'accounts/addDoubleEntry',
    getPaymentTypes: 'accounts/getPaymentTypes',
    getDoubleEntryList: 'accounts/getDoubleEntryList',
    addPaymentType: 'accounts/addPaymentType',
    updatePaymentType: 'accounts/updatePaymentType',
    changePaymentTypeStatus: 'accounts/changePaymentTypeStatus',
    getMasterAccountRoleTotals: 'accounts/getMasterAccountRoleTotals'
};

export const getMasterAccountRoles = (params) => handleApiRequest('GET', GET_API_ENDPOINTS.getMasterAccountRoles, params);
export const addEmployeePortalStatus = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.addEmployeePortalStatus, payload);
export const getMasterAccounts = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getMasterAccounts, payload);
export const addDoubleEntry = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.addDoubleEntry, payload);
export const getPaymentTypes = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getPaymentTypes, payload);
export const getDoubleEntryList = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getDoubleEntryList, payload);
export const addPaymentType = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.addPaymentType, payload);
export const updatePaymentType = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updatePaymentType, payload);
export const changePaymentTypeStatus = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.changePaymentTypeStatus, payload);
export const getMasterAccountRoleTotals = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getMasterAccountRoleTotals, payload);
